module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/WxYRo7/CoverDesign.jpg?1685327736204",
      "alt": "This image is the cover for the book Mensonges de famille: Sebastian"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mensonges de famille: Sebastian\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sebastian  Orwell fait la seule chose que ferait un magicien intelligent quand il tombe sur le Prince Héritier blessé : il le guérit et l’abandonne dans une taverne où il ne sera pas son problème. Malheureusement, le prince ne se contente pas de rester en vie, il le pourchasse pour le remercier personnellement. Non seulement Sebastian est coincé avec l’affection indésirable du prince, mais il est aussi confronté à la preuve grandissante que la tentative d’assassinat a été orchestrée par quelqu’un appartenant au passé de son père.")]), _vm._v(" "), _c('p', [_vm._v("Lord Orwell est beaucoup de choses : voleur, menteur, ivrogne et un père horrible, mais Sebastian sait qu’il n’est pas un meurtrier. Afin de le prouver, il devra garder le prince en vie assez longtemps pour découvrir la vérité – une tâche rendue considérablement plus ardue, car le prince préfère le courtiser au lieu de veiller à sa propre survie. Par-dessus tout, Sebastian doit sauver la situation sans révéler ses pouvoirs magiques ni la véritable raison pour laquelle il dissimule son apparence.")]), _vm._v(" "), _c('p', [_vm._v("Sebastian n’a aucune intention de jouer au héros, mais celui qui sème la zizanie dans son pays, va devoir payer pour avoir détruit sa petite vie tranquille.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sam Argent, Lily Karey\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0